module.exports = __webpack_public_path__ + "img/bar-line-chart.8e50ee6b.svg";